import React from "react";
import AnimatedPlanning from "./components/AnimatedPlanning/AnimatedPlanning";

const Planning: React.FC = () => {
    return (
        <><AnimatedPlanning /></>
    );
};

export default Planning ;